import React from 'react';
import { Reveal } from './showcase/Reveal';
import { CallVignette } from './showcase/CallVignette';
export function HomeCallMoment() {
  return <section id="after-hours" aria-labelledby="after-hours-title" className="border-b border-white/5 bg-ink-800" data-id="element-116" data-mp="1s2shzco0ffmx">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-117" data-mp="1idheq6nt156y">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-118" data-mp="1ibed0pdahnme">
          <Reveal delay={0.05} data-id="element-119" data-mp="14cofj8mk5lxi">
            <CallVignette data-id="element-120" data-mp="19d2r30ndbe0a" />
          </Reveal>
          <Reveal delay={0.12} data-id="element-121" data-mp="19duaze7lrnaq">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-122" data-mp="19azqjmola2hb">
              Product in action
            </p>
            <h2 id="after-hours-title" className="mt-4 max-w-md font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-123" data-mp="zed7n3ftplhx">
              9:42 PM. Your agents are done for the day. The phone is not.
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-124" data-mp="yk5nkpis5l27">
              Answered live, qualified, booked. Demo data shown.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}